import { useState } from "react";
import { 
    PhoneIcon, 
    EnvelopeIcon, 
    MagnifyingGlassIcon,
    BoltIcon,
    UserGroupIcon,
    ChatBubbleBottomCenterTextIcon 
} from "@heroicons/react/24/outline";
import { setOnboardingStorage } from "utils/onboardingStorage";

const OnboardingSurvey = (props: { onNext: any }) => {
    const { onNext } = props;
    const [selected, setSelected] = useState<string[]>([]);

    const prospectingMethods = [
        {
            id: "cold-calling",
            label: "Appels à froid",
            icon: PhoneIcon,
            description: "Prospection téléphonique directe"
        },
        {
            id: "personalized-email",
            label: "Emails personnalisés",
            icon: EnvelopeIcon,
            description: "Campagnes d'emailing sur-mesure"
        },
        {
            id: "automated-email",
            label: "Emails automatisés",
            icon: BoltIcon,
            description: "Séquences d'emails automatiques"
        },
        {
            id: "seo-content",
            label: "SEO / Contenu",
            icon: MagnifyingGlassIcon,
            description: "Référencement naturel et articles"
        },
        {
            id: "linkedin",
            label: "LinkedIn",
            icon: UserGroupIcon,
            description: "Prospection sur les réseaux sociaux"
        },
        {
            id: "direct-messaging",
            label: "Messagerie directe",
            icon: ChatBubbleBottomCenterTextIcon,
            description: "WhatsApp, SMS, etc."
        }
    ];

    const toggleSelection = (id: string) => {
        if (selected.includes(id)) {
            setSelected(selected.filter(item => item !== id));
        } else {
            setSelected([...selected, id]);
        }
    };

    const handleContinue = () => {
        if (selected.length === 0) {
            alert("Veuillez sélectionner au moins une méthode de prospection");
            return;
        }
        setOnboardingStorage("prospectingMethods", selected.join(","));
        onNext();
    };

    return (
        <div className="flex flex-col items-center justify-between min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 px-6 py-12">
            <div className="w-full max-w-5xl">
                {/* Title */}
                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 text-center">
                    Quelles méthodes de prospection utilisez-vous ?
                </h1>
                <p className="text-gray-500 mb-10 text-center max-w-2xl mx-auto">
                    Sélectionnez toutes les méthodes que vous utilisez actuellement pour prospecter vos clients CHR
                </p>

                {/* Options Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 w-full mb-8">
                {prospectingMethods.map((method) => {
                    const Icon = method.icon;
                    const isSelected = selected.includes(method.id);
                    
                    return (
                        <button
                            key={method.id}
                            onClick={() => toggleSelection(method.id)}
                            className={`p-6 rounded-2xl border transition-all text-left hover:shadow-md ${
                                isSelected
                                    ? "border-orange-400 bg-orange-50/50 shadow-sm"
                                    : "border-gray-200 bg-white hover:border-gray-300"
                            }`}
                        >
                            <div className="flex items-start gap-4">
                                <div className={`p-3 rounded-xl ${
                                    isSelected ? "bg-gradient-to-br from-orange-400 to-orange-500" : "bg-gray-100"
                                }`}>
                                    <Icon className={`h-6 w-6 ${
                                        isSelected ? "text-white" : "text-gray-500"
                                    }`} />
                                </div>
                                <div className="flex-1">
                                    <h3 className={`font-semibold mb-1 ${
                                        isSelected ? "text-orange-700" : "text-gray-900"
                                    }`}>
                                        {method.label}
                                    </h3>
                                    <p className="text-sm text-gray-600">
                                        {method.description}
                                    </p>
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>

            </div>

            {/* Bottom Navigation */}
            <div className="w-full max-w-2xl">
                <div className="flex gap-4">
                    <button
                        className={`flex-1 px-8 py-4 font-semibold rounded-xl transition-all text-lg ${
                            selected.length > 0
                                ? "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700"
                                : "bg-gray-200 text-gray-400 cursor-not-allowed"
                        }`}
                        onClick={handleContinue}
                        disabled={selected.length === 0}
                    >
                        Continuer
                    </button>
                </div>
                <p className="text-sm text-gray-400 text-center mt-4">
                    {selected.length} méthode{selected.length !== 1 ? "s" : ""} sélectionnée{selected.length !== 1 ? "s" : ""}
                </p>
            </div>
        </div>
    );
};

export default OnboardingSurvey;
